import { useContext } from "react";
import { AuthContext, AuthContextProps } from ".";

export const useAuthenticationContext = (): AuthContextProps => {
	const context = useContext(AuthContext);
	if (!context) {
		throw new Error("useCompanyContext must be used within a CompanyProvider");
	}
	return context;
};
